import formReducer from 'redux-form/lib/reducer';
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import audioSegments from './audioSegments';
import browser from './browser';
import compliance from './compliance';
import episodePreview from './episodePreview';
import episodes from './episodes';
import errorModal from './errorModal';
import localStorage from './localStorage';
import money from './money';
import onboarding from './onboarding';
import pageMetadata from './pageMetadata';
import podcast from './podcast';
import podcastAnalytics from './podcastAnalytics';
import podcastEditor from './podcastEditor';
import playbackDurationTracking from './playbackDurationTracking';
import playbackPosition from './playbackPosition';
import recorder from './recorder';
import resetPassword from './resetPassword';
import search from './search';
import sourceAudio from './sourceAudio';
import station from './station';
import transcriptions from './transcriptions';
import unsavedChangesTracker from './unsavedChangesTracker';
import user from './user';
import tutorial from './tutorial';
import supportersScreenReducer from './screens/SupportersScreen/duck/reducers';
import supportersCancelScreenReducer from './screens/SupportersCancelScreen/duck/reducers';
import settingsScreenReducer from './screens/SettingsScreen/duck/reducers';
import preDistributionModalScreenReducer from './screens/PreDistributionModalScreen/duck/reducers';
import podcastReducer from './store/global/podcast/reducers';
import dashboardScreenReducer from './screens/DashboardScreen/duck/reducers';
import coverArtModalScreenReducer from './screens/CoverArtModalScreen/duck/reducers';
import episodeEditorScreenReducer from './screens/EpisodeEditorScreen/duck';
import splitSegmentAudioModalScreenReducer from './screens/SplitSegmentAudioModalScreen/duck';
import adRecordingModalScreenReducer from './screens/AdRecordingModalScreen/duck';
import voiceMessageCreationModalScreenReducer from './screens/VoiceMessageCreationModalScreen/duck/reducers';
import episodesScreenReducer from './screens/EpisodesScreen/duck';
import sponsorshipsTutorialModalScreenReducer from './screens/SponsorshipsTutorialModalScreen/duck';

import { _episodesByIdReducer } from './store/_episodesById/reducers';
import { _podcastReducer } from './store/_podcast/reducers';

export default {
  adRecordingModalScreen: adRecordingModalScreenReducer,
  episodesScreen: episodesScreenReducer,
  coverArtModalScreen: coverArtModalScreenReducer,
  dashboardScreen: dashboardScreenReducer,
  episodeEditorScreen: episodeEditorScreenReducer,
  preDistributionModalScreen: preDistributionModalScreenReducer,
  settingsScreen: settingsScreenReducer,
  splitSegmentAudioModalScreen: splitSegmentAudioModalScreenReducer,
  sponsorshipsTutorialModalScreen: sponsorshipsTutorialModalScreenReducer,
  supportersScreen: supportersScreenReducer,
  supportersCancelScreen: supportersCancelScreenReducer,
  _podcast: _podcastReducer,
  _episodesById: _episodesByIdReducer,
  global: combineReducers({
    podcast: podcastReducer,
  }),
  audioSegments,
  browser,
  compliance,
  episodePreview,
  episodes,
  errorModal,
  form: formReducer,
  localStorage,
  money,
  onboarding,
  pageMetadata,
  playbackDurationTracking,
  playbackPosition,
  podcast,
  podcastAnalytics,
  podcastEditor,
  recorder,
  resetPassword,
  routing: routerReducer,
  search,
  sourceAudio,
  station,
  transcriptions,
  unsavedChangesTracker,
  user,
  tutorial,
  voiceMessageCreationModalScreen: voiceMessageCreationModalScreenReducer,
};
